<template>
  <v-container fluid>
    <v-card>
      <v-alert dense class="ma-0 mr-2">Модуль - {{ softwareName }}</v-alert>
      <v-alert dense class="ma-0 mr-2">Версия - {{ this.$route.params.softwareVersion }}</v-alert>
      <v-col>
        <v-btn @click="goBack" :color="'green'">Назад</v-btn>
      </v-col>
    </v-card>
    <v-card>
      <v-col>

        <v-data-table :headers="tableHeaders" :items="getStatisticsByVersion.filter(
          (item) =>
            item.object_code.toString().includes(search) ||
            item.object_name.toLowerCase().includes(search.toLowerCase()) ||
            item.dealer_code.toString().includes(search) ||
            item.date.toString().includes(search)
        )
          " :items-per-page="50" :hide-default-footer="true" :sort-by="sortBy" :search="search" dense
          class="elevation-1" no-data-text="Нет данных для создания таблицы" item-key="object_code">

          <template v-slot:top="{ pagination, options, updateOptions }">
            <div class="d-flex" >
              <v-text-field v-model="search" prepend-icon="mdi-magnify" label="Поиск"
                hide-details style="border-top: 1px solid #E0E0E0; border-radius: 4px 0px 0px 0px;"
                class="mt-0 pl-4"></v-text-field>

              <v-data-footer :pagination="pagination" :options="options" @update:options="updateOptions"
                :items-per-page-options="[10, 20, 50, 100]" items-per-page-text="Записей на странице:"
                page-text="{0}-{1} из {2}" show-first-last-page style="border-radius: 0px 4px 0px 0px;"/>
            </div>
          </template>

          <template v-slot:[`item.object_name`]="{ item }">
            <a :href="`https://lic.carbis.ru/objects/${item.object_code}`" target="_blank"
              style="text-decoration: none; color: black">{{ item.object_name }}</a>
          </template>

          <template v-slot:[`item.dealer_name`]="{ item }">
            <a :href="`https://lic.carbis.ru/dealers/${item.dealer_code}`" target="_blank"
              style="text-decoration: none; color: black">{{ item.dealer_name }}</a>
          </template>

        </v-data-table>
      </v-col>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      tableHeaders: [
        { text: "Код объекта", value: "object_code" },
        { text: "Название объекта", value: "object_name", sortable: true },
        { text: "Дилер", value: "dealer_name", sortable: true },
        { text: "Дата", value: "date", sortable: true },
      ],
      sortBy: ["date"],
      search: "",
      softwareDataLoaded: false,
    };
  },
  watch: {
    $route(to) {
      const softwareCode = parseInt(to.params.softwareCode);
      const softwareVersion = to.params.softwareVersion;
      if (softwareCode && softwareVersion) {
        this.fetchStatisticsByVersion({
          softwareCode,
          softwareVersion,
        });
      }
    },
  },
  computed: {
    ...mapGetters(["getStatisticsByVersion", "softwareData"]),
    softwareName() {
      const code = parseInt(this.$route.params.softwareCode);
      if (!this.softwareDataLoaded) return "Загрузка...";
      return this.softwareData[code] || "Неизвестное ПО";
    }
  },
  async created() {
    await this.createSoftwareData();
    this.softwareDataLoaded = true;

    const softwareCode = parseInt(this.$route.params.softwareCode);
    const softwareVersion = this.$route.params.softwareVersion;
    if (softwareCode && softwareVersion) {
      this.fetchStatisticsByVersion({ softwareCode, softwareVersion });
    }
  },
  methods: {
    ...mapActions(["fetchStatisticsByVersion", "createSoftwareData"]),
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
